import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonTenantOverview, CommonTenantTopics } from "../../CommonComponents/CommonTenantViews";

export const TenantsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.tenants,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTenantOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonTenantTopics />;
    },
};
